import React from 'react';

export default function Tawk ({ page }) {
  return (
    <button onClick={() => window.Tawk_API.toggle()} className={`tawkButton btn ${page}`}>
      <span className='text'>Support</span> <i className='icon icon-message'></i>
    </button>
  )
}
